import { COLORS } from '../../styles/theme'
import styled from 'styled-components'

export const Page = styled.div`
  overflow: hidden;
  #button-container {
    position: absolute;
    bottom: 4vh;
    left: 2%;
    .hot-buttons {
      width: 125px;
      box-shadow: 0px 5px 4px -4px #000;
    }
    .back-hall {
      min-width: 130px;
    }
  }
  .hot-buttons,
  .hot-actions {
    background: linear-gradient(#ff9821, #f83636);
    border-radius: 40px;
    border: 2px solid #ff9821;
    padding: 8px 16px;
    color: ${COLORS.hotButtonText};
    margin: 0 8px;
    small {
      margin: 0;
      display: block;
      font-weight: 500;
      font-size: 70%;
    }
  }
  .booth-container {
    position: fixed;
    width: 85vw;
    max-width: 1280px;
    top: 65%;
    left: 50%;
    transform: translate(-50%, -65%);
    .kiosk-img {
      position: inherit;
      height: 70%;
      width: 19%;
      left: -20%;
      bottom: 2%;
      cursor: pointer;
      .start-quiz {
        position: absolute;
        top: 0%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 55%;
      }
      .kiosk-stand {
        position: absolute;
        top: 0;
        width: 100%;
      }
      .kiosk-poster {
        position: absolute;
        top: 4%;
        bottom: 40.5%;
        left: 18%;
        right: 17%;
      }
      .kiosk-poster-skew {
        transform: skewX(6deg);
        position: absolute;
        top: 4.5%;
        bottom: 43.5%;
        left: 25%;
        right: 23%;
      }
    }
    .hot-actions {
      border-radius: 50%;
      padding: 0;
      img,
      svg {
        transition: 2000ms ease;
        width: 24px;
        height: 24px;
      }
      small {
        transition: 2000ms ease;
        font-size: 1px;
        opacity: 0;
        color: ${COLORS.hotButtonText};
        display: none;
      }
      &:hover {
        small {
          font-size: 8px;
          opacity: 1;
          display: block;
        }
        small.extra-small {
          font-size: 6px;
        }
        img,
        svg {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
  #tawk-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 40vw;
    height: 40vh;
    z-index: 9999;
  }
  .exhibitor-title {
    text-align: right;
    width: 40vw;
    position: fixed;
    bottom: 3%;
    right: 5%;
    font-weight: 600;
  }
  .video-gallery {
    top: 42%;
    right: 16%;
  }
  .video-gallery-2 {
    top: 42%;
    right: 22%;
  }
  .video-gallery-3 {
    top: 42%;
    left: 26%;
  }
  .poster {
    top: 35%;
    left: 36%;
  }
  .poster-2 {
    top: 45%;
    left: 30%;
  }
  .poster-3 {
    top: 45%;
    right: 36%;
  }
  .pdf {
    top: 62%;
    right: 33%;
  }
  .pdf-2 {
    top: 52%;
    right: 16%;
  }
  .pdf-3 {
    top: 62%;
    right: 14%;
  }
  .chat {
    top: 62%;
    right: 24%;
  }
  .chat-2 {
    top: 62%;
    left: 34%;
  }
  .chat-3 {
    top: 62%;
    left: 24%;
  }
  .namecard {
    top: 62%;
    right: 10%;
  }
  .namecard-2 {
    top: 62%;
    right: 34%;
  }
  .namecard-3 {
    top: 62%;
    left: 10%;
  }
  .info {
    top: 12%;
    right: 16%;
  }
  .info-2 {
    top: 5%;
    right: 30%;
  }
  .info-3 {
    top: 8%;
    left: 18%;
  }
`
export const HotButton = styled.button`
  position: absolute;
  animation: heartbeat 7s infinite;
  width: 55px;
  height: 55px;
  background: ${COLORS.hotButtonBg};
  border-radius: 40px;
  border: 2px solid ${COLORS.hotButtonText};
  padding: 8px 16px;
  color: ${COLORS.hotButtonText};
  margin: 0 8px;
  small {
    margin: 0;
    display: block;
    font-weight: 500;
    font-size: 70%;
  }
`
